import { Modal } from '@studiometa/ui';
import Cookies from 'js-cookie';

/**
 * PopinConditional
 */
export default class PopinConditional extends Modal {
  static config = {
    name: 'PopinConditional',
    options: {
      daysDuration: {
        type: Number,
        default: '0',
      },
    },
  };

  timeoutDuration = 60000;

  /**
   * mounted hook
   */
  mounted() {
    if (Cookies.get(`meta_popinconditionnal`) !== 'true') {
      setTimeout(() => {
        this.open();
        Cookies.set(`meta_popinconditionnal`, 'true', {
          expires: this.$options.daysDuration,
        });
      }, this.timeoutDuration);
    }
  }
}
